import { StyleSheet, css } from 'aphrodite'
import type React from 'react'
import { useState } from 'react'
import type { Stop } from '../constants/stopsData'
import { DurationSelector } from './DurationSelector'

interface AddStopModalProps {
  isOpen: boolean
  onClose: () => void
  onSave: (stop: Stop) => void
}

const AddStopModal: React.FC<AddStopModalProps> = ({
  isOpen,
  onClose,
  onSave,
}) => {
  const [stopReason, setStopReason] = useState<string>('')
  const [duration, setDuration] = useState<string>('')

  const handleSave = () => {
    const newStop: Stop = {
      id: Date.now().toString(),
      label: stopReason,
      checked: true,
      duration: duration,
    }

    onSave(newStop)
    onClose()
    setStopReason('')
    setDuration('')
  }

  if (!isOpen) return null

  return (
    <div className={css(styles.modalOverlay)}>
      <div className={css(styles.modal)}>
        <div className={css(styles.modalContent)}>
          <h3 className={css(styles.title)}>Add Delay</h3>

          <div className={css(styles.inputGroup)}>
            <label className={css(styles.label)}>Delay Reason</label>
            <input
              type="text"
              value={stopReason}
              onChange={(e) => setStopReason(e.target.value)}
              className={css(styles.input)}
              placeholder="Enter stop reason"
              maxLength={100}
            />
          </div>

          <div className={css(styles.inputGroup)}>
            <label className={css(styles.label)}>Duration</label>
            <DurationSelector value={duration} onChange={setDuration} />
          </div>

          <div className={css(styles.buttons)}>
            <button className={css(styles.cancelButton)} onClick={onClose}>
              Cancel
            </button>
            <button
              className={css(styles.saveButton)}
              onClick={handleSave}
              disabled={!stopReason.trim() || !duration}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

const styles = StyleSheet.create({
  modalOverlay: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    height: '100%',
    display: 'flex',
    alignItems: 'flex-end',
    zIndex: 1000,
  },
  modal: {
    backgroundColor: 'white',
    width: '100%',
    borderTopLeftRadius: '16px',
    borderTopRightRadius: '16px',
    padding: '20px',
    animation: 'slideUp 0.3s ease-out',
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  title: {
    fontSize: '18px',
    fontWeight: 600,
    marginBottom: '8px',
    textAlign: 'center',
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  label: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#374151',
  },
  input: {
    padding: '10px',
    borderRadius: '8px',
    border: '1px solid #E5E7EB',
    fontSize: '14px',
    width: '100%',
    boxSizing: 'border-box',
    fontFamily: 'Inter',
  },
  buttons: {
    display: 'flex',
    gap: '12px',
    marginTop: '16px',
  },
  saveButton: {
    flex: 1,
    padding: '12px',
    backgroundColor: '#1C64F2',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontWeight: 600,
    ':disabled': {
      backgroundColor: '#E5E7EB',
      cursor: 'not-allowed',
    },
  },
  cancelButton: {
    flex: 1,
    padding: '12px',
    backgroundColor: 'white',
    border: '1px solid #E5E7EB',
    borderRadius: '8px',
    fontWeight: 600,
  },
  toggleButton: {
    background: 'none',
    border: 'none',
    color: '#1C64F2',
    fontSize: '14px',
    padding: '4px 0',
    cursor: 'pointer',
    marginTop: '8px',
  },
})

export default AddStopModal
